var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-radio-group-key"},_vm._l((_vm.options),function(element,index){return _c('sprradio',{key:element.value,attrs:{"id":`radiogp_${_vm._uid}_${index}`,"value":element.value,"title":element.text,"model-value":_vm.value,"is-valid":true,"name":_vm.groupName},on:{"input":_vm.handleSelection}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }